import request from '@/utils/request'

export interface DeviceFeature {
  id: number
  deviceId: number
  featureId: number
  durationType: 'permanent' | 'days' | 'months' | 'years'
  durationValue?: number
  startDate?: Date
  endDate?: Date
  sourceType: string
  sourceReference?: string
  isActive: boolean
  metadataJson?: any
  notes?: string
  feature?: {
    id: number
    featureKey: string
    name: string
    description?: string
  }
  createdAt: Date
  updatedAt: Date
}

export const getDeviceFeatures = (serialNumber: string, includeExpired = false) =>
  request({
    url: `/devices/${serialNumber}/features`,
    method: 'get',
    params: { includeExpired }
  })

export const addDeviceFeature = (serialNumber: string, data: {
  featureKey: string
  durationType: 'permanent' | 'days' | 'months' | 'years'
  durationValue?: number
  sourceType?: string
  sourceReference?: string
  startDate?: string
  notes?: string
  metadata?: any
}) =>
  request({
    url: `/devices/${serialNumber}/features`,
    method: 'post',
    data
  })

export const updateDeviceFeature = (serialNumber: string, featureKey: string, data: {
  durationType?: 'permanent' | 'days' | 'months' | 'years'
  durationValue?: number
  isActive?: boolean
  notes?: string
  metadata?: any
}) =>
  request({
    url: `/devices/${serialNumber}/features/${featureKey}`,
    method: 'put',
    data
  })

export const removeDeviceFeature = (serialNumber: string, featureKey: string) =>
  request({
    url: `/devices/${serialNumber}/features/${featureKey}`,
    method: 'delete'
  })

// Row-ID targeted variants. Multiple device_features rows per (device,
// feature) are now allowed, so deletion by featureKey alone is ambiguous.
// Prefer these when the UI already has the row id.
export const updateDeviceFeatureById = (serialNumber: string, featureRowId: number, data: {
  durationType?: 'permanent' | 'days' | 'months' | 'years'
  durationValue?: number
  isActive?: boolean
  notes?: string
  metadata?: any
}) =>
  request({
    url: `/devices/${serialNumber}/features/row/${featureRowId}`,
    method: 'put',
    data
  })

export const removeDeviceFeatureById = (serialNumber: string, featureRowId: number) =>
  request({
    url: `/devices/${serialNumber}/features/row/${featureRowId}`,
    method: 'delete'
  })
